import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import {PersonLogin} from '../person/person-login';
import {SelectionItem} from '../selections/selection-item';
import {PersonLoginService} from '../services/person-login-service';
import {SelectionService} from '../services/selection-service';
import {TaskDelegationService} from '../services/task-delegation-service';
import {DateUtils} from '../utils/date-utils';
import {StringUtils} from '../utils/string-utils';
import {PersonDelegation} from './person-delegation';
import {Router} from '@angular/router';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';


@Component({
    selector: 'person-delegation',
    templateUrl: './person-delegation.component.html',
    styleUrls: ['./person-delegation.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, MatButton, MatIcon, MatDatepickerInput, MatDatepickerToggle, MatDatepicker, MatProgressSpinner, DatePipe]
})
export class PersonDelegationComponent implements OnInit {
  private readonly personLoginService = inject(PersonLoginService);
  private readonly delegationService = inject(TaskDelegationService);
  private readonly selectionService = inject(SelectionService);
  private readonly router = inject(Router);


  private personLogin!: PersonLogin;
  readonly delegations = signal<PersonDelegation[]>(undefined!);
  readonly delegationUsers = signal<SelectionItem[]>(undefined!);
  selectedDelegation!: PersonDelegation;
  readonly isBusy = signal<boolean>(false);
  readonly errorMessage = signal<string>(undefined!);

  formatDisplayDate(input: Date): Date {
    return DateUtils.formatDisplay(input);
  }

  setStartTime(newValue: Date) {
    this.selectedDelegation.startTime = DateUtils.formatOutput(newValue);
  }

  setEndTime(newValue: Date) {
    this.selectedDelegation.endTime = DateUtils.formatOutput(newValue);
  }

  private loadDelegations(): void {
    this.isBusy.set(true);
    this.delegationService.getUserDelegations().subscribe(results => {
      this.delegations.set(results);
      this.isBusy.set(false);
      this.selectedDelegation = null!;
    }, error => this.handleError(error));
  }

  private loadSelectionLists(): void {
    this.selectionService.getDelegationUsers().subscribe(result => this.delegationUsers.set(result));
  }

  selectDelegation(delegation: PersonDelegation) {
    this.selectedDelegation = JSON.parse(JSON.stringify(delegation));
  }

  cancelUpdate(): void {
    this.selectedDelegation = null!;
  }

  endNow(): void {
    this.selectedDelegation.endTime = this.selectedDelegation.startTime;
    this.saveDelegation();
  }

  newDelegation(): void {
    this.selectedDelegation = new PersonDelegation();
    this.selectedDelegation.assignee = this.personLogin.token;
    this.setStartTime(new Date());
    this.setEndTime(new Date());
  }

  saveDelegation(): void {
    this.isBusy.set(true);
    this.errorMessage.set(undefined!);
    this.delegationService.save(this.selectedDelegation).subscribe(() => this.loadDelegations(), error => this.handleError(error));
  }

  private handleError(error: HttpErrorResponse) {
    this.isBusy.set(false);
    this.errorMessage.set(StringUtils.getErrorMessage(error));
  }

  ngOnInit(): void {
    if (this.personLoginService.isOutsideEngineer()) {
      this.router.navigate(['ratings']);
    } else {
      this.personLogin = this.personLoginService.getCachedLogin()!;
      this.loadSelectionLists();
      this.loadDelegations();
    }
  }

}
